module.exports = __webpack_public_path__ + "static/media/Sandor Clegane 2.5955ae20.jpg";